// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as StockTransferForm from "./StockTransferForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation createStockTransfer($input: InputCreateStockTransfer!, $productsInput: [InputCreateStockTransferProduct!]!)  {\ncreateStockTransfer(input: $input, productsInput: $productsInput)  {\n__typename  \nid  \nsenderShop  {\n__typename  \nid  \n}\n\nrecipientShop  {\n__typename  \nid  \n}\n\nproducts  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nquantity  \nsenderStock  \nrecipientStock  \nsenderVariant  {\n__typename  \nid  \n}\n\nrecipientVariant  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createStockTransfer;
  let value$2 = value$1.senderShop;
  let value$3 = value$1.recipientShop;
  let value$4 = value$1.products;
  let value$5 = value$4.edges;
  return {
    createStockTransfer: {
      __typename: value$1.__typename,
      id: value$1.id,
      senderShop: {
        __typename: value$2.__typename,
        id: value$2.id
      },
      recipientShop: {
        __typename: value$3.__typename,
        id: value$3.id
      },
      products: {
        __typename: value$4.__typename,
        edges: value$5.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.senderVariant;
          let value$3 = value$1.recipientVariant;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              quantity: value$1.quantity,
              senderStock: value$1.senderStock,
              recipientStock: value$1.recipientStock,
              senderVariant: {
                __typename: value$2.__typename,
                id: value$2.id
              },
              recipientVariant: {
                __typename: value$3.__typename,
                id: value$3.id
              }
            }
          };
        })
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.createStockTransfer;
  let value$2 = value$1.products;
  let value$3 = value$2.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.recipientVariant;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let recipientVariant = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.senderVariant;
    let value$6 = value$5.id;
    let value$7 = value$5.__typename;
    let senderVariant = {
      __typename: value$7,
      id: value$6
    };
    let value$8 = value$1.recipientStock;
    let value$9 = value$1.senderStock;
    let value$10 = value$1.quantity;
    let value$11 = value$1.__typename;
    let node = {
      __typename: value$11,
      quantity: value$10,
      senderStock: value$9,
      recipientStock: value$8,
      senderVariant: senderVariant,
      recipientVariant: recipientVariant
    };
    let value$12 = value.__typename;
    return {
      __typename: value$12,
      node: node
    };
  });
  let value$4 = value$2.__typename;
  let products = {
    __typename: value$4,
    edges: edges
  };
  let value$5 = value$1.recipientShop;
  let value$6 = value$5.id;
  let value$7 = value$5.__typename;
  let recipientShop = {
    __typename: value$7,
    id: value$6
  };
  let value$8 = value$1.senderShop;
  let value$9 = value$8.id;
  let value$10 = value$8.__typename;
  let senderShop = {
    __typename: value$10,
    id: value$9
  };
  let value$11 = value$1.id;
  let value$12 = value$1.__typename;
  let createStockTransfer = {
    __typename: value$12,
    id: value$11,
    senderShop: senderShop,
    recipientShop: recipientShop,
    products: products
  };
  return {
    createStockTransfer: createStockTransfer
  };
}

function serializeInputObjectInputCreateStockTransfer(inp) {
  return {
    senderShopId: inp.senderShopId,
    recipientShopId: inp.recipientShopId
  };
}

function serializeInputObjectInputCreateStockTransferProduct(inp) {
  return {
    quantity: inp.quantity,
    senderVariantId: inp.senderVariantId,
    recipientVariantId: inp.recipientVariantId
  };
}

function serializeVariables(inp) {
  let a = inp.productsInput;
  return {
    input: serializeInputObjectInputCreateStockTransfer(inp.input),
    productsInput: a.map(serializeInputObjectInputCreateStockTransferProduct)
  };
}

function makeVariables(input, productsInput, param) {
  return {
    input: input,
    productsInput: productsInput
  };
}

function makeInputObjectInputCreateStockTransfer(senderShopId, recipientShopId, param) {
  return {
    senderShopId: senderShopId,
    recipientShopId: recipientShopId
  };
}

function makeInputObjectInputCreateStockTransferProduct(quantity, senderVariantId, recipientVariantId, param) {
  return {
    quantity: quantity,
    senderVariantId: senderVariantId,
    recipientVariantId: recipientVariantId
  };
}

let CreateStockTransferMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateStockTransfer: serializeInputObjectInputCreateStockTransfer,
  serializeInputObjectInputCreateStockTransferProduct: serializeInputObjectInputCreateStockTransferProduct,
  makeVariables: makeVariables,
  makeInputObjectInputCreateStockTransfer: makeInputObjectInputCreateStockTransfer,
  makeInputObjectInputCreateStockTransferProduct: makeInputObjectInputCreateStockTransferProduct
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateStockTransferMutation_useWithVariables = include.useWithVariables;

let CreateStockTransferMutation = {
  CreateStockTransferMutation_inner: CreateStockTransferMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateStockTransfer: serializeInputObjectInputCreateStockTransfer,
  serializeInputObjectInputCreateStockTransferProduct: serializeInputObjectInputCreateStockTransferProduct,
  makeVariables: makeVariables,
  makeInputObjectInputCreateStockTransfer: makeInputObjectInputCreateStockTransfer,
  makeInputObjectInputCreateStockTransferProduct: makeInputObjectInputCreateStockTransferProduct,
  use: use,
  useWithVariables: CreateStockTransferMutation_useWithVariables
};

function makeMutationVariables(param) {
  return {
    input: {
      senderShopId: param.senderShopId,
      recipientShopId: param.recipientShopId
    },
    productsInput: param.products.map(product => ({
      quantity: product.quantity,
      senderVariantId: product.senderVariantId,
      recipientVariantId: product.recipientVariantId
    }))
  };
}

function StockTransferFormActions(props) {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return JsxRuntime.jsx(StockTransferForm.SubmitButton.make, {
    label: I18n.t("Finalize"),
    onSubmit: (param, values) => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, makeMutationVariables(values))), undefined, param => param.createStockTransfer.id)
  });
}

let make = React.memo(StockTransferFormActions);

export {
  CreateStockTransferMutation,
  makeMutationVariables,
  make,
}
/* query Not a pure module */
